import { jsx as _jsx } from "react/jsx-runtime";
import { Banner, Text } from '@dixa/lib-shared-habla';
export const PartnerIntegrationsWidgetError = () => {
    return (_jsx(Banner, { variant: "warning", description: _jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4" }, { children: "Something went wrong. Either the requested widget does not exist or there is no ID in the URL." })) }));
};
